import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
    Theme,
    ListItem,
    ListItemText,
    ListItemIcon,
    Chip,
    Box,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { UserLight } from 'models/users';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            paddingRight: theme.spacing(2),
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
        },
    }),
);

interface OverviewProps {
    user: UserLight;
    onClick?: () => void;
}

const UserListItem: React.FunctionComponent<OverviewProps> = ({
    user,
    onClick,
}) => {
    const classes = useStyles();

    return (
        <ListItem
            button
            className={classes.root}
            onClick={() => onClick && onClick()}
        >
            <ListItemIcon>
                <AccountCircleIcon
                    style={{ color: user.isActive ? 'black' : 'grey' }}
                    fontSize="large"
                />
            </ListItemIcon>
            <ListItemText primary={user.fullName} secondary={user.email} />
            <Box>
                {user.groups.map((group) => (
                    <Chip size="small" key={group} label={group} />
                ))}
            </Box>
        </ListItem>
    );
};

UserListItem.displayName = 'UserListItem';
export default UserListItem;
